export type PlatformModule = {
  id: string;
  kicker: string;
  title: string;
  description: string;
  bullets: string[];
  screenTitle: string;
  screenDetail: string;
};

export const platformModules: PlatformModule[] = [
  {
    id: "detect",
    kicker: "KPI Trend Monitor",
    title: "Spot performance drift before it costs another week.",
    description:
      "Track core paid-search KPIs, compare trend windows, and move from a declining metric to the likely root cause and recommended response.",
    bullets: [
      "Conversion, CPA, CTR, CPC, and impression-share trends",
      "Root-cause explanations, not isolated alerts",
      "Recommended actions linked to each finding",
    ],
    screenTitle: "KPI Trend Monitor",
    screenDetail: "Core KPI monitoring + root-cause analysis",
  },
  {
    id: "decide",
    kicker: "Weekly Action Plan",
    title: "Turn diagnostics into a ranked plan your team can execute.",
    description:
      "DBM separates critical repairs from performance optimizations and expansion opportunities, then shows the expected impact, time, and confidence behind every move.",
    bullets: [
      "Critical repairs surfaced first",
      "Impact, time, and confidence on every action",
      "Apply, pause, or investigate from one queue",
    ],
    screenTitle: "Action Plan",
    screenDetail: "Prioritized actions with impact + confidence",
  },
  {
    id: "scale",
    kicker: "Budget Monitoring",
    title: "Keep spend paced to plan—and opportunity.",
    description:
      "See where the account will finish before month-end, then increase, decrease, or reallocate campaign budgets with daily refreshed recommendations.",
    bullets: [
      "Live month pacing and projected finish",
      "Increase, decrease, and reallocation recommendations",
      "Campaign-level budget guardrails",
    ],
    screenTitle: "Budget Monitoring",
    screenDetail: "Live pacing + daily budget recommendations",
  },
  {
    id: "explain",
    kicker: "Executive Summary",
    title: "Make account health legible in one view.",
    description:
      "Summarize issues and financial exposure across campaigns, keywords, ad copy, budgets, and landing pages—then drill into the evidence.",
    bullets: [
      "Account-level issue summary",
      "Campaign and asset health drilldowns",
      "Warnings and cost exposure in plain language",
    ],
    screenTitle: "Executive Summary",
    screenDetail: "Account health + issue exposure",
  },
];

export const platformModuleById = (id: string) => platformModules.find((m) => m.id === id);